import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
// import "./Tableform.css";
import image from "../../../../images/logo1.png"
import {

} from '../../../actions/GenomicsSampleAccessioningActions';
import { connect } from 'react-redux';
import ReactToPrint from "react-to-print";

import { useRef } from 'react';
const useStyles = makeStyles({
    table: {
        height: "40px"
    },
    left: {
        margin: 600,
        width: "50%"
    },
    fontsize13: {
        fontSize: "13px",
    },
    rightContentHeader: {
        width: "88%",
        float: "left",
        textAlign: "left",
        paddingRight: "20px",
    },
    style: {
        background: "#AD70A6",
        color: "#fff",
        padding: 10,
        marginLeft: 5,
    }

});
interface Props {

}
const PhleboAdminViewBooking: React.FC<Props> = ({


}) => {


    const [id, setId] = useState<any>(0)


    // useEffect(() => {
    //     if (bookingId !== 0) {
    //         getBookingById(bookingId)
    //         getHivPackage(`?booking=${bookingId}`)

    //         getQRCodeData(bookingId)
    //         getSignature(bookingId)

    //     }
    // }, [bookingId])



    const classes = useStyles();
    const contentArea = useRef<any>(0)
    const componentRef = useRef<any>(null);
    //   const pid = booking && booking?.customer_name + "-" + booking && booking?.pk;
    const [personName, setPersonName] = useState<any>("main")
    // const handleExportWithFunction = () => {
    //     savePDF(contentArea.current, { paperSize: "A4"});
    //     //  window.print

    // }

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const reactToPrintTrigger = React.useCallback(() => {
        return <button style={{ marginLeft: "10px" }}>Print Receipt</button>;
    }, []);





    return (
        <>
            <div>
                <div style={{ height: "20px", marginTop: "35%" }}>
                    <h2></h2>
                    <div className={classes.rightContentHeader}>

                        <ReactToPrint
                            content={reactToPrintContent}
                            trigger={reactToPrintTrigger}
                        />
                    </div>
                </div>
            </div>
            <div
                style={{
                    width: 842,
                    background: "#f1f1f1",
                    margin: "20px auto",
                    padding: 20
                }}
            >

                <div ref={componentRef}>
                    <div style={{ width: "100%", display: "flex", background: "#b2ff59", marginTop: "52px" }}>
                        <div style={{ width: "50%", textAlign: "left", padding: 15 }}>
                            <h3><img src={image} alt="logo" style={{ width: "150px" }} /></h3>
                        </div>
                        <div style={{ width: "50%", textAlign: "right", padding: 15 }}>
                            <div style={{ color: "black", fontWeight: "bold" }}><h4>TRF-Cytogenics</h4></div>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#b2ff59", padding: 10 }}>Sample Id</div>
                        <input></input>
                    </div>
                    {/* //section1 */}
                    <div
                        style={{ width: "100%", background: "#b2ff59", textAlign: "center" }}
                    >
                        <h3 style={{ padding: 10 }}>PATIENT DETAILS</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            Name
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            HusbandName
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            DOB
                        </div>
                        <input type="date" style={{ width: "15%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Age
                        </div>
                        <input style={{ width: "15%" }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Gender
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 5, width: "15%" }}>
                            <input type="radio" id="M" value="M" />  <label id="M">M</label>
                            <input type="radio" id="F" value="F" />  <label id="F">F</label>
                        </div>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Consangunity
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 5, width: "15%" }}>
                            <input type="radio" id="Y" value="Y" />  <label id="Y">Y</label>
                            <input type="radio" id="N" value="N" />  <label id="N">N</label>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            Address
                        </div>
                        <input style={{ width: "100%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            city
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            State
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Pincode
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            PhoneNo.
                        </div>
                        <input type="number" style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Email
                        </div>
                        <input type="email" style={{ width: "60%", marginLeft: 5 }}></input>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            margin: "10px 0px",
                            border: "1px solid",
                            height: "90px"
                        }}
                    >
                        <div style={{ padding: 10, width: "100%" }}>
                            I rquest genetic testing at Redcliffe Life Science and my particular
                            is under medical advice
                        </div>
                        <div style={{ width: "100%", display: "flex" }}>
                            <div style={{ padding: 10, textAlign: "left", width: "50%" }}>
                                Date: <input type="date" />
                            </div>
                            <div style={{ padding: 10, textAlign: "right", width: "50%" }}>
                                Signature: <input type="file" />
                            </div>
                        </div>
                    </div>
                    {/* //section2 */}
                    <div
                        style={{ width: "100%", background: "#b2ff59", textAlign: "center" }}
                    >
                        <h3 style={{ padding: 10 }}>TEST REQUESTED</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            Test Name
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 5 }}>
                            <input
                                type="checkbox"
                                id="Karyotype"
                                name="Karyotype"
                                value="Karyotype"
                            />
                            <label id="Karyotype">Karyotype</label>
                            <input
                                type="checkbox"
                                id="ChromosomalMicroarray"
                                name="ChromosomalMicroarray"
                                value="ChromosomalMicroarray"
                            />
                            <label id="ChromosomalMicroarray">ChromosomalMicroarray</label>
                            <input type="checkbox" id="315K" name="315K" value="315K" />
                            <label id="315K">315K</label>
                            <input type="checkbox" id="750K" name="750K" value="750K" />
                            <label id="750K">750K</label>
                            <input type="checkbox" id="HD" name="HD" value="HD" />
                            <label id="HD">HD</label>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <input
                            type="checkbox"
                            id="SangerSequencing"
                            name="SangerSequencing"
                            value="SangerSequencing"
                        />
                        <label id="SangerSequencing">SangerSequencing</label>
                        <input
                            type="checkbox"
                            id="Fish(SpecifyProbes)"
                            name="Fish(SpecifyProbes)"
                            value="Fish(SpecifyProbes)"
                        />
                        <label id="Fish(SpecifyProbes)">Fish(SpecifyProbes)</label>
                        <input
                            type="checkbox"
                            id="SpecificGeneVariantAnalysis(Specify)"
                            name="SpecificGeneVariantAnalysis(Specify)"
                            value="SpecificGeneVariantAnalysis(Specify)"
                        />
                        <label id="SpecificGeneVariantAnalysis(Specify)">
                            SpecificGeneVariantAnalysis(Specify)
                        </label>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <input
                            type="checkbox"
                            id="Others(Specify)"
                            name="Others(Specify)"
                            value="Others(Specify)"
                        />
                        <label id="Others(Specify)">Others(Specify)</label>
                        <input />
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            Sample Collection Date And Time
                        </div>
                        <input
                            type="datetime-local"
                            style={{ width: "68%", marginLeft: 5 }}
                        ></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            Sample Type
                        </div>
                        <div style={{ marginTop: 10, marginLeft: 5 }}>
                            <input
                                type="checkbox"
                                id="Blood (in EDTA tube)"
                                name="Blood (in EDTA tube)"
                                value="Blood (in EDTA tube)"
                            />
                            <label id="Blood (in EDTA tube)">Blood (in EDTA tube)</label>
                            <input
                                type="checkbox"
                                id="Blood (in PAX gene tube)"
                                name="Blood (in PAX gene tube)"
                                value="Blood (in PAX gene tube)"
                            />
                            <label id="Blood (in PAX gene tube)">
                                Blood (in PAX gene tube)
                            </label>
                            <input
                                type="checkbox"
                                id="Blood(Heparin tube)"
                                name="Blood(Heparin tube)"
                                value="Blood(Heparin tube)"
                            />
                            <label id="Blood(Heparin tube)">Blood(Heparin tube)</label>
                            <input type="checkbox" id="DNA" name="DNA" value="DNA" />
                            <label id="DNA">DNA</label>
                            <input
                                type="checkbox"
                                id="Buccal Swab"
                                name="Buccal Swab"
                                value="Buccal Swab"
                            />
                            <label id="Buccal Swab">Buccal Swab</label>
                        </div>
                    </div>
                    <div style={{ marginTop: 10, marginLeft: 5 }}>
                        <input
                            type="checkbox"
                            id="Fresh Frozen Tissue"
                            name="Fresh Frozen Tissue"
                            value="Fresh Frozen Tissue"
                        />
                        <label id="Fresh Frozen Tissue">Fresh Frozen Tissue</label>
                        <input
                            type="checkbox"
                            id="FFPE Tissue Block | Block no:"
                            name="FFPE Tissue Block | Block no:"
                            value="FFPE Tissue Block | Block no:"
                        />
                        <label id="FFPE Tissue Block | Block no:">
                            FFPE Tissue Block | Block no:
                        </label>
                        <input
                            type="checkbox"
                            id="Other Sample Site (Specify Site):"
                            name="Other Sample Site (Specify Site):"
                            value="Other Sample Site (Specify Site):"
                        />
                        <label id="Other Sample Site (Specify Site):">
                            Other Sample Site (Specify Site):
                        </label>
                        <input />
                    </div>
                    {/* //section3 */}
                    <div
                        style={{ width: "100%", background: "#b2ff59", textAlign: "center" }}
                    >
                        <h3 style={{ padding: 10 }}>CLINICIAN DETAILS</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            Name
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Hospital
                        </div>
                        <input style={{ width: "40%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            Address
                        </div>
                        <input style={{ width: "100%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ background: "#43a047", color: "#fff", padding: 10 }}>
                            PhoneNo.
                        </div>
                        <input type="number" style={{ width: "40%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Email
                        </div>
                        <input type="email" style={{ width: "60%", marginLeft: 5 }}></input>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            margin: "10px 0px",
                            border: "1px solid",
                            height: "100px"
                        }}
                    >
                        <div style={{ padding: 10, width: "95%" }}>
                            I am ordering the test(s) for my Patient above. I certify that
                            appropriate information has been provided regarding testing and the
                            patient has consented to get the test performed at your laboratory.
                        </div>
                        <div style={{ width: "100%", display: "flex" }}>
                            <div style={{ padding: 10, textAlign: "left", width: "40%" }}>
                                Date: <input type="date" />
                            </div>
                            <div style={{ padding: 10, textAlign: "right", width: "60%" }}>
                                Clinicians Signature: <input type="file" />
                            </div>
                        </div>
                    </div>
                    {/* //section4 */}
                    <div
                        style={{
                            width: "100%",
                            background: "#43a047",
                            color: "#fff",
                            textAlign: "center"
                        }}
                    >
                        <h3 style={{ padding: 10 }}>CLINICAL NOTES AND FAMILY HISTORY</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <textarea style={{ width: "100%", marginLeft: 5 }} />
                    </div>
                    <div
                        style={{
                            width: "100%",
                            background: "#43a047",
                            color: "#fff",
                            textAlign: "center",
                            padding: 10
                        }}
                    >
                        <h2>Redcliffe Life Tech Pvt.Ltd.</h2>
                        <h4>
                            H-55, Sector-63, Electronic City Noida, Noida-201301 (U.P) INDIA,
                            Phone: 898 898 1777
                            <br /> www.redcliffelabs.com
                        </h4>
                    </div>
                </div>
                <div
                    style={{
                        width: 842,
                        background: "#f1f1f1",
                        margin: "20px auto",
                        padding: 20
                    }}
                >
                    <div
                        style={{ width: "100%", background: "#b2ff59", textAlign: "center" }}
                    >
                        <h3 style={{ padding: 10 }}>
                            DETAILS OF ACCOMPANYING SAMPLES (IF ANY)
                        </h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                width: "45%"
                            }}
                        >
                            Name
                        </div>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5,
                                width: "10%"
                            }}
                        >
                            Age
                        </div>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5,
                                width: "15%"
                            }}
                        >
                            Gender
                        </div>
                        <div
                            style={{
                                background: "#43a047",
                                color: "#fff",
                                padding: 10,
                                marginLeft: 5,
                                width: "30%"
                            }}
                        >
                            Relationship with Patient
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ width: "42.3%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginLeft: 5, width: "11.3%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginLeft: 5, width: "15.6%", display: "flex" }}>
                            <input type="radio" id="M" value="M" />  <label id="M">M</label>
                            <input type="radio" id="F" value="F" />  <label id="F">F</label>
                        </div>
                        <div style={{ marginLeft: 5, width: "29%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ width: "42.3%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginLeft: 5, width: "11.3%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginLeft: 5, width: "15.6%", display: "flex" }}>
                            <input type="radio" id="M" value="M" />  <label id="M">M</label>
                            <input type="radio" id="F" value="F" />  <label id="F">F</label>
                        </div>
                        <div style={{ marginLeft: 5, width: "29%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ width: "42.3%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginLeft: 5, width: "11.3%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginLeft: 5, width: "15.6%", display: "flex" }}>
                            <input type="radio" id="M" value="M" />  <label id="M">M</label>
                            <input type="radio" id="F" value="F" />  <label id="F">F</label>
                        </div>
                        <div style={{ marginLeft: 5, width: "29%", display: "flex" }}>
                            <input style={{ width: "100%" }} />
                        </div>
                    </div>
                    <div
                        style={{ width: "100%", background: "#b2ff59", textAlign: "center" }}
                    >
                        <h3 style={{ padding: 10 }}>TERMS & CONDITIONS</h3>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            margin: "10px 0px",
                            display: "flex"
                        }}
                    >
                        <div style={{ padding: 10, width: "50%", textAlign: "left" }}>
                            <b style={{ fontSize: "14px" }}>DELIVERY OF SERVICES</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                Subject to receipt of the Fees, Redcliffe Lab ("Redcliffe") shall
                                carry out the test(s) as requested in this Test Requisition Form
                                ("Test(s)") in conformity with the applicable industry standards.
                            </p>
                            <b style={{ fontSize: "14px" }}>REPORTS</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                The Report shall be generated within such Turn-Around-Time ("TAT")
                                as mentioned in this Test Requisition Form(s). However, such TAT
                                may vary depending upon the complexity of Test(s) requested.
                                Redcliffe shall under no circumstances be liable for any delay
                                beyond the aforementioned TAT. It is hereby clarified that the
                                Report(s) generated from the Test(s) do not provide any diagnosis
                                or opinion or recommends any cure in any manner. Redcliffe hereby
                                recommends the Patient and/or the guardians of the Patients to
                                take assistance of the Clinician or a certified physician or
                                doctor, to interpret the Report(s) thus generated. Redcliffe
                                hereby disclaims all liability arising in connection with the
                                Report(s).
                            </p>
                            <b style={{ fontSize: "14px" }}>FEES</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                The fees specified by Redcliffe for the Test(s) ("Fees") are
                                exclusive of taxes. All taxes and levies as required under
                                applicable laws shall be charged in addition TERMINATION It is
                                agreed that if the Test(s) requested in this Test Requisition Form
                                is terminated for any reason whatsoever, Redcliffe shall not be
                                required to refund the Fees paid in advance by the Patient and/or
                                the guardians of the Patients for the Test(s). However, refund
                                shall be awarded if and only if the sample provided doesn't pass
                                the QC or if the sample provided is inadequate for performing the
                                test. LIMITATION OF LIABILITY In addition to any disclaimer of
                                liability provided by Redcliffe elsewhere in this test Requisition
                                Form, Redcliffe further disclaims any and all liability arising
                                out of any claim, liability, demand, compensation, loss, damage,
                                judgment or other obligation or right of action which is suffered
                                by the Clinician and/or the Patient and/or the guardians of the
                                Patients or any third party whether directly or indirectly for
                                relying on the Report(s) and/or in relation to the Test(s) availed
                                under this Test Requisition Form(s). FEES to the Fees. The mode of
                                payment of Fees and the details of the Test(s) for which the
                                payment of Fees is made should be notified to Redcliffe in advance
                                either through telephone by dialing its Single Point Contact No.
                                +91-8882-914-915 or through e-mail by mailing at its e-mail id:
                                care@redcliffels.com. All Fees should be paid in conformity with
                                the Payment Details' provided in this Test Requisition Form.
                                Redcliffe shall not be liable towards the Fees if the payment for
                                the Fees is not made in the manner provided herein. To avoid any
                                confusions pertaining to the payment of Fees and the Test(s)
                                requested, the Patients and/or their guardians are hereby advised
                                to confirm the successful remittance of the Fees and the details
                                of the Test(s) requested at the earliest either through telephone
                                by dialing the Toll-Free No or through e-mail by mailing at the
                                email provided above.
                            </p>
                            <b style={{ fontSize: "14px" }}>TERM</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                This Terms & Conditions shall become effective from the date of
                                signing of this Test Requisition Form and shall remain valid,
                                effective and binding till delivery of the Report.
                            </p>
                            <b style={{ fontSize: "14px" }}>TERMINATION</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                It is agreed that if the Test(s) requested in this Test
                                Requisition Form is terminated for any reason whatsoever,
                                Redcliffe shall not be required to refund the Fees paid in advance
                                by the Patient and/or the guardians of the Patients for the
                                Test(s). However, refund shall be awarded if and only if the
                                sample provided doesn't pass the QC or if the sample provided is
                                inadequate for performing the test.
                            </p>
                        </div>
                        <div style={{ padding: 10, width: "50%", textAlign: "left" }}>
                            <b style={{ fontSize: "14px" }}>ROLES &RESPONSIBILITIES</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                By signing this Test Requisition Form, in addition to the
                                warranties made by the Clinician elsewhere in this Test
                                Requisition Form, the Clinician warrants that the information
                                provided in this Test Requisition Form is true and correct and
                                that the Clinicians have the necessary rights, permissions and
                                authorities to extract the Sample from the Patient and provide the
                                sample for the Test(s) to Redcliffe. While Redcliffe can help in
                                sample shipment it is not liable for any sample damage that may
                                occur during collection and transport from the collection
                                center/hospital to Redcliffe laboratory facility. In case of
                                inadequate samples or failure of QC with respect to sample
                                provided for test, Redcliffe may seek for further samples to
                                perform the tests. If further samples are not provided for tests,
                                then Redcliffe will deduct the costs incurred for such sample
                                provided and refund the balance amount. The Clinicians and/or the
                                Patient and/or the guardians of the Patients, shall jointly and
                                severally, defend, indemnify and hold harmless Redcliffe from and
                                against any claim, liability, demand, compensation, loss, damage,
                                judgment or other obligation or right of action which may arise
                                out of and/or in relation to the Test(s) requested in this Test
                                Requisition Form and/or this Terms & Conditions.
                            </p>
                            <b style={{ fontSize: "14px" }}> LIMITATION OF LIABILITY</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                In addition to any disclaimer of liability provided by Redcliffe
                                elsewhere in this test Requisition Form, Redcliffe further
                                disclaims any and all liability arising out of any claim,
                                liability, demand, compensation, loss, damage, judgment or other
                                obligation or right of action which is suffered by the Clinician
                                and/or the Patient and/or the guardians of the Patients or any
                                third party whether directly or indirectly for relying on the
                                Report(s) and/or in relation to the Test(s) availed under this
                                Test Requisition Form(s).
                            </p>
                            <b style={{ fontSize: "14px" }}>
                                GOVERNING LAW, JURISDICTION AND DISPUTE RESOLUTION
                            </b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                These Terms and Conditions and this Test Requisition Form shall be
                                governed by and construed in accordance with Indian law and the
                                courts in Gurgaon Haryana shall have exclusive injunctive
                                jurisdiction. In the event of any dispute, controversy or claim
                                whatsoever arising from these Terms and Conditions and/ or this
                                Test Requisition Form, the parties shall undertake to make every
                                effort to reach an amicable settlement within fifteen (15) days
                                upon reference of the dispute by any party through discussions
                                among the concerned representatives of parties, failing which the
                                dispute, controversy or claim shall be settled by Arbitration by a
                                Sole Arbitrator appointed by the Gurgaon Court, Gurgaon, Haryana
                                as per Indian Arbitration and Conciliation Act, 1996 as amended
                                from time to time. The venue of arbitration shall be Gurgaon and
                                it shall be conducted in English language. The award passed by the
                                Sole Arbitrator shall be final and binding upon the parties.
                            </p>
                            <b style={{ fontSize: "14px" }}>NOTICE</b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                All notices, statements or other communication required or
                                permitted to be given or made shall be in writing and in English
                                language. Such notices will deliver by hand or sent by prepaid
                                post with recorded delivery, or facsimile transmission addressed
                                to the intended recipient at the address mentioned in this Test
                                Requisition Form.
                            </p>
                            <b style={{ fontSize: "14px" }}>INDEPENDENT PARTIES </b>
                            <p style={{ textAlign: "justify", fontSize: "14px" }}>
                                All parties effected hereunder are independent entities and
                                neither of the parties are an agent, employee or joint venture of
                                the other and they shall not represent themselves as such to any
                                third parties.
                            </p>
                        </div>
                    </div>
                    <div
                        style={{ width: "100%", background: "#b2ff59", textAlign: "center" }}
                    >
                        <h3 style={{ padding: 10 }}>PAYMENT INSTRUCTION</h3>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <input style={{ width: "15%", marginLeft: 5 }}></input>
                        <input style={{ width: "20%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                fontSize: 14,
                                padding: 10,
                                marginLeft: 5,
                                width: "100%"
                            }}
                        >
                            DD/Cheque Should be Drawn In Favor Of "Redcliffe Lifetech Pvt. Ltd™
                            Payble At "Delhi"
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ padding: 10 }}>Amount:</div>
                        <input style={{ width: "20%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            In Words:
                        </div>
                        <input style={{ width: "56%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px" }}>
                        <div style={{ padding: 10 }}>DD/Cheque No./Ref. No:</div>
                        <input type="number" style={{ width: "20%", marginLeft: 5 }}></input>
                        <div
                            style={{
                                padding: 10,
                                marginLeft: 5
                            }}
                        >
                            Bank Name
                        </div>
                        <input type="email" style={{ width: "18%", marginLeft: 5 }}></input>
                        <div style={{ padding: 10 }}>Date</div>
                        <input type="date" style={{ width: "15%", marginLeft: 5 }}></input>
                    </div>
                    <div style={{ padding: 10, width: "95%" }}>
                        ONLINE TRANSFER OR DIRECT CASH DEPOSIT, REDCLIFFE LIFETECH PVT. LTD
                        ACCOUNT: 50200057800880, IFSC CODE: HDFC0000975, SEC-63 NOIDA
                    </div>
                    <div
                        style={{
                            width: "100%",
                            background: "#43a047",
                            color: "#fff",
                            textAlign: "center",
                            padding: 10
                        }}
                    >
                        <h2>Redcliffe Life Tech Pvt.Ltd.</h2>
                        <h4>
                            H-55, Sector-63, Electronic City Noida, Noida-201301 (U.P) INDIA,
                            Phone: 898 898 1777
                            <br /> www.redcliffelabs.com
                        </h4>
                    </div>

                </div>
            </div >
        </>
    );
}
const mapStateToProps = (state: any) => ({


})

export default connect(mapStateToProps, {

})(PhleboAdminViewBooking);